"use client";

import * as React from "react";

import { useFetchApi } from "@/composables/useFetchApi";
import { getBrandSlug } from "@/lib/strapi";
import {
  buildInstagramMediaPath,
  normalizeInstagramMediaPayload,
  type InstagramMediaPost,
} from "@/services/instagramMedia";

export type UseInstagramMediaOptions = {
  brandSlug?: string;
  enabled?: boolean;
  limit?: number;
  path?: string;
  initialData?: unknown | null;
};

export function useInstagramMedia(options?: UseInstagramMediaOptions) {
  const brandSlug = options?.brandSlug ?? getBrandSlug();
  const path = options?.path ?? buildInstagramMediaPath(brandSlug);

  const state = useFetchApi<unknown>(path, {
    enabled: options?.enabled ?? true,
    withBrandFilter: false,
    initialData: options?.initialData,
  });

  const posts = React.useMemo<InstagramMediaPost[]>(
    () => normalizeInstagramMediaPayload(state.data, { limit: options?.limit }),
    [options?.limit, state.data],
  );

  return { ...state, posts };
}
